import React, { useContext } from 'react';
import { View } from 'react-native';
import { Icon } from '@rneui/themed';
import { fetchPage } from '../../../common/Api';
import AppContext from '../../../contexts/App';

const NavFooter = ({ bottomNav }) => {
    const { dispatch } = useContext(AppContext);
    const contentItems = bottomNav.contentItems?.['bottom Navigation Links']?.contentItems;
    const iconSize = 26;

    return (
        <View
            style={{
                alignItems: 'center',
                backgroundColor: '#4a5a6a',
                bottom: 0,
                flexDirection: 'row',
                justifyContent: 'space-around',
                marginTop: 10,
                width: '100%'
            }}
        >
            {contentItems &&
                Object.values(contentItems).map(icon => {
                    const id = icon?.id;
                    const fontCharacterClass = icon?.fontCharacterClass;
                    const link = icon?.link;

                    return (
                        <Icon
                            key={id}
                            name={fontCharacterClass}
                            size={iconSize}
                            color='#fff'
                            type='font-awesome'
                            containerStyle={{ padding: 8 }}
                            solid={true}
                            onPress={async () => await fetchPage(dispatch, link)}
                        />
                    );
                })}
        </View>
    );
};

export default NavFooter;
